import config from "../config/config";
// import { decryptData } from "../hooks/useAuth";
import { printFormData } from "../utils/commonUtils";
import { decryptData } from "../utils/encryptionUtils";

const apiURL = config.API_URL;


const getTokens = () => {
    const storedAuth = localStorage.getItem("auth");

    if (storedAuth) {
        const decryptedTokens = decryptData(storedAuth);
        return decryptedTokens;
    }

    return null;
};

export const bookmarkSearch = async (searchQuery) => {
    const API = `${apiURL}/glassyfied/search/bookmarks/?q=${searchQuery.searchQuery}`;
    const tokens = getTokens();

    if (!tokens || !tokens.accessToken) {
        return null;
    }

    try {
        const response = await fetch(API, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokens.accessToken}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};

export const apiKeyDetails = async () => {
    const API = `${apiURL}/glassyfied/api-key-details/`;
    const tokens = getTokens();


    if (!tokens || !tokens.accessToken) {
        return null;
    }

    try {
        const response = await fetch(API, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokens.accessToken}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};

export const updateAPIKey = async (data) => {
    const API = `${apiURL}/glassyfied/update-api-key/`;
    const tokens = getTokens();


    if (!tokens || !tokens.accessToken) {
        return null;
    }

    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokens.accessToken}`,
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};

export const registerUser = async (data) => {
    const API = `${apiURL}/account/register/`;
    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }
        return response.json();
    } catch (error) {
        throw error;
    }
};

export const changeName = async (data) => {
    const API = `${apiURL}/account/change-name/`;
    const tokens = getTokens();

    if (!tokens || !tokens.accessToken) {
        return null;
    }

    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokens.accessToken}`,
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};


export const verifyRegistrationEmail = async (data) => {
    const API = `${apiURL}/account/verify-registration-email/${data.uid}/${data.token}`;
    try {
        const response = await fetch(API, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};

export const logoutUser = async (data) => {
    const API = `${apiURL}/account/logout/`;
    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${data.accessToken}`,
            },
            body: JSON.stringify({ refresh_token: data.refreshToken }),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};

export const loginUser = async (data) => {
    const API = `${apiURL}/account/login/`;
    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};

export const sendPasswordResetEmail = async (data) => {
    const API = `${apiURL}/account/send-password-reset-email/`;
    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};

export const resetPassword = async (data) => {
    const API = `${apiURL}/account/reset-password/${data.uid}/${data.token}/`;
    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ new_password: data.password, confirm_new_password: data.confirmPassword }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};

export const changePassword = async ({ authToken, passwordData }) => {
    const API = `${apiURL}/account/change-password/`;
    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken.accessToken}`,
            },
            body: JSON.stringify(passwordData),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        return response.json();
    } catch (error) {
        throw error;
    }
};

export const userQuery = async ({ requestData }) => {
    const API = `${apiURL}/glassyfied/user-query/`;
    const tokens = getTokens();

    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                // "Content-Type": "application/json",
                // "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${tokens.accessToken}`,
            },
            // body: JSON.stringify(requestData),
            body: requestData,
        });

        // Check if the response is not okay
        if (!response.ok) {
            const errorData = await response.json(); // Get the error response
            throw new Error(`Error ${response.status}`);
        }

        return await response.json(); // Return the successful response
    } catch (error) {
        throw error; // Re-throw the error to be handled by the calling function
    }
};


export const userFeedback = async (data) => {
    const API = `${apiURL}/glassyfied/feedback/`;
    const tokens = getTokens();

    if (!tokens || !tokens.accessToken) {
        throw new Error("Authorization tokens are missing.");
    }

    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokens.accessToken}`,
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error ${response.status}: ${errorData.message || "Failed to submit feedback."}`);
        }

        return await response.json();
    } catch (error) {
        throw error;  // Re-throw to handle errors at the caller level
    }
};


export const chatHistory = async () => {
    const API = `${apiURL}/glassyfied/chat-history/`;
    const tokens = getTokens();

    if (!tokens || !tokens.accessToken) {
        throw new Error("Authorization tokens are missing.");
    }

    try {
        const response = await fetch(API, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokens.accessToken}`,
            },
            // body: JSON.stringify({}),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error ${response.status}: ${errorData.message || "Failed to submit feedback."}`);
        }

        return await response.json();
    } catch (error) {
        throw error;  // Re-throw to handle errors at the caller level
    }
};


export const mdToPDF = async (data) => {
    const API = `${apiURL}/glassyfied/md-to-pdf/`;
    const tokens = getTokens();

    if (!tokens || !tokens.accessToken) {
        throw new Error("Authorization tokens are missing.");
    }

    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokens.accessToken}`,
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error ${response.status}: ${errorData.message || "Failed to submit feedback."}`);
        }

        return await response.json();
    } catch (error) {
        throw error;  // Re-throw to handle errors at the caller level
    }
};


export const getBookmarks = async () => {
    const API = `${apiURL}/glassyfied/get-bookmarks/`;
    const tokens = getTokens();

    if (!tokens || !tokens.accessToken) {
        throw new Error("Authorization tokens are missing.");
    }

    try {
        const response = await fetch(API, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokens.accessToken}`,
            },
            // body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error ${response.status}: ${errorData.message || "Failed to submit feedback."}`);
        }

        return await response.json();
    } catch (error) {
        throw error;  // Re-throw to handle errors at the caller level
    }
};


export const contactUsSubmission = async (data) => {
    const API = `${apiURL}/glassyfied/contact-us/`;

    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error ${response.status}: ${errorData.message || "Failed to submit feedback."}`);
        }

        return await response.json();
    } catch (error) {
        throw error;  // Re-throw to handle errors at the caller level
    }
};

export const registeredUserContactSubmission = async (data) => {
    const API = `${apiURL}/glassyfied/registered-contact-submissions/create/`;
    const tokens = getTokens();

    try {
        const response = await fetch(API, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokens.accessToken}`,
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error ${response.status}: ${errorData.message || "Failed to submit feedback."}`);
        }

        return await response.json();
    } catch (error) {
        throw error;  // Re-throw to handle errors at the caller level
    }
};


// export const getRegisteredUserContactSubmissions = async () => {
//     console.log("getRegisteredUserContactSubmissions");
//     const API = `${apiURL}/glassyfied/contact-submissions/`;
//     const tokens = getTokens();

//     try {
//         const response = await fetch(API, {
//             method: "GET",
//             headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${tokens.accessToken}`,
//             },
//         });

//         if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(`Error ${response.status}: ${errorData.message || "Failed to fetch submissions."}`);
//         }

//         return await response.json();
//     } catch (error) {
//         throw error; // Re-throw to handle errors at the caller level
//     }
// };
